var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKanaSeed(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.3333H26.6667C30.2029 13.3333 33.5943 11.9286 36.0948 9.42808C38.5952 6.9276 40 3.53622 40 0H13.3333C9.79711 0 6.40573 1.40476 3.90524 3.90524C1.40476 6.40572 0 9.7971 0 13.3333Z",
    fill: "url(#paint0_linear_10064_8915)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 26.6666H13.3333C9.79711 26.6666 6.40573 25.2618 3.90524 22.7613C1.40476 20.2608 0 16.8695 0 13.3333H26.6667C30.2029 13.3333 33.5943 14.738 36.0948 17.2385C38.5952 19.739 40 23.1304 40 26.6666Z",
    fill: "url(#paint1_linear_10064_8915)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 40.0001H26.6667C30.2029 40.0001 33.5943 38.5953 36.0948 36.0948C38.5952 33.5943 40 30.203 40 26.6667H13.3333C9.79711 26.6667 6.40573 28.0715 3.90524 30.572C1.40476 33.0725 0 36.4638 0 40.0001Z",
    fill: "url(#paint2_linear_10064_8915)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10064_8915",
    x1: -0.00000100773,
    y1: 13.3333,
    x2: 10.6487,
    y2: 25.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BB96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10064_8915",
    x1: 5,
    y1: 14.111,
    x2: 5.40849,
    y2: 26.6471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BB96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10064_8915",
    x1: -9.08722e-7,
    y1: 39.0001,
    x2: 7.92712,
    y2: 52.3616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9E4D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#78BB96"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKanaSeed);
export default __webpack_public_path__ + "static/media/kana-seed.0fbedc064935a1fc7a9aec5ec6faeeaf.svg";
export { ForwardRef as ReactComponent };